import './App.css';
import {Routes,Route} from 'react-router-dom'
import Sidebar from './components/Sidebar';
import { useSelector } from 'react-redux'
import { selectToggle} from './redux/features/sidebarSlice'
import classes from './styles/Products.module.scss'
import { ProtectedRoute } from './components/ProtectedRoute';
import { Suspense, lazy } from "react";

const Men = lazy(() => import('./pages/Men'));
const Women = lazy(() => import('./pages/Women'));
const Home = lazy(() => import('./pages/Home'));
const Cart = lazy(() => import('./pages/Cart'));
const ProductDetails = lazy(() => import('./pages/Product-details'));
const Shipping = lazy(() => import('./pages/Shipping'));
const Order = lazy(() => import('./pages/Order'));
const ProductUpload = lazy(() => import('./pages/Product-upload'));
const Dashboard = lazy(() => import('./pages/admin/Dashboard'));
const AllProducts = lazy(() => import('./pages/admin/AllProducts'));
const Orders = lazy(() => import('./pages/admin/Orders'));
const Login = lazy(() => import('./pages/admin/login'));
const Users = lazy(() => import('./pages/admin/Users'));

function App() {
  const open=useSelector(selectToggle)
  return (
    <div className="App">
        <div className={open ? classes.bg : ''}><Sidebar /></div>
       <Routes>
        <Route path="/" element={<Suspense fallback={<>...</>}>
            <Home />
          </Suspense>}/>
        {/* <Route path="/watches" element={<Watches />} /> */}
        <Route path="/men" element={
          <Suspense fallback={<>...</>}>
            <Men />
          </Suspense>
        } />


        <Route path="/women" element={<Suspense fallback={<>...</>}>
            <Women />
          </Suspense>} />
        {/* <Route path="/children" element={<Children />} /> */}
        <Route path="/cart" element={<Suspense fallback={<>...</>}>
            <Cart />
          </Suspense>} />
        
        <Route path="/:brand/:id" element={<Suspense fallback={<>...</>}>
            <ProductDetails />
          </Suspense>} />
        {/* <Route path="/login" element={<Auth />} /> */}
        <Route path="/shipping" element={<Suspense fallback={<>...</>}>
            <Shipping />
          </Suspense>} />
        {/* <Route path="/payment" element={<Payment />} /> */}
        <Route path="/order" element={<Suspense fallback={<>...</>}>
            <Order />
          </Suspense>} />
        
        {/* Protected routes are meant to be visited only by admin */}
        <Route path="/admin/product-upload" element={<ProtectedRoute><Suspense fallback={<>...</>}>
            <ProductUpload />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/dashboard" element={<ProtectedRoute><Suspense fallback={<>...</>}>
            <Dashboard />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/products" element={<ProtectedRoute><Suspense fallback={<>...</>}>
            <AllProducts />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/product/update/:id" element={<ProtectedRoute><Suspense fallback={<>...</>}>
            <ProductUpload />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/orders" element={<ProtectedRoute><Suspense fallback={<>...</>}>
            <Orders />
          </Suspense></ProtectedRoute>} />
        <Route path="/admin/login" element={<Suspense fallback={<>...</>}>
            <Login />
          </Suspense>} />
        <Route path="/admin/users" element={<ProtectedRoute><Suspense fallback={<>...</>}>
            <Users />
          </Suspense></ProtectedRoute>} />
      </Routes>
    </div>
  );
}

export default App;
